<template>
  <div class="safedigindiana">
    <SafeDigHeader />
    <div class="siteSidebarAndContent siteSidebarAndContentWhiteBg">
      <div class="content contentNoPadding">
        <div class="homeContainer">
          <div class="homeTopContainer">
            <div class="homeTopInnerContainer">
              <div class="homeTopStatementContainer homeTopStatementSafedigindianaContainer">
                <div class="safedigCardCarousel" style="position: relative; text-align: center; width: 100%;">
                  <div class="safedigHomepageHeader minHeightHeaderCard">
                    <div class="safedigPaddedContainer minHeightHeaderCard safedigDoublePad"
                      :style="{ backgroundImage: `url(${heroBgImage})` }">
                      <h2>{{ $t('homepage.welcomeTo') }}</h2>
                      <br>
                      <h1 class="desktopBlock safedigLargeHeader">{{ $t('homepage.safeDigIndiana') }}</h1>
                      <br>
                      <div>
                        <span class="safedigHomepageHeaderText">
                          {{ $t('homepage.heroText') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- End Homepage Header Section -->
                  <!-- Please Select Your Page Section -->
                  <div class="safedigHomepageHeaderOverlay">
                    <span data-v-1c44b7a6=""
                      style="color: rgb(255, 255, 255); font-weight: bold; letter-spacing: 8px; flex-basis: 100%; font-size: 29px; padding-bottom: 80px;">{{ $t('homepage.pleaseSelectYourPage') }}</span>
                    <div class="safedigProfessionalsCard">
                      <div class="safedigCardOverlay">
                        <span>{{ $t('homepage.professionals') }}</span>
                        <br>
                        <router-link to="/professionals">
                          <button type="button" class="safedigButton marginTop2">{{ $t('homepage.accessYourTraining') }}</button>
                        </router-link>
                      </div>
                    </div>
                    <div class="safedigHomeownersCard">
                      <div class="safedigCardOverlay">
                        <span>{{ $t('homepage.homeowners') }}</span>
                        <br>
                        <router-link to="/homeowners">
                          <button type="button" class="safedigButton marginTop2">{{ $t('homepage.accessYourTraining') }}</button>
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <!-- End Please Select Your Page Section -->
                  <!-- Helpful Links Section: cards overlap blue band (top) and footerOffWhite (bottom) -->
                  <div class="safedigHelpfulLinksWrapper">
                    <h2 class="safedigHelpfulLinksHeader">{{ $t('homepage.helpfulLinks') }}</h2>
                    <div class="safedigHelpfulLinksBand"></div>
                    <div class="safedigHelpfulLinksCardsRow">
                      <div class="safedigHelpfulLinksCard">
                        <img src="../../../assets/safe-dig/notify811_holyMoley_scaled.png" width="100%" :alt="$t('homepage.notify811')">
                        <div class="cardInfoBox">
                          <h2>{{ $t('homepage.notify811') }}</h2>
                          <span>{{ $t('homepage.notify811Description') }}</span>
                          <br>
                          <div class="buttonContainer">
                            <a href="https://indiana811.org/pros/" target="_blank" rel="noopener noreferrer">
                              <button type="button" class="safedigButton leftButton">{{ $t('homepage.siteProfessionals') }}</button>
                            </a>
                            <a href="https://indiana811.org/homeowners/" target="_blank" rel="noopener noreferrer">
                              <button type="button" class="safedigButton rightButton">{{ $t('homepage.homeownersLabel') }}</button>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="safedigHelpfulLinksCard safedigCardLeftMargin">
                        <img src="../../../assets/safe-dig/map_cropped_scaled.png" width="100%" :alt="$t('homepage.pipelineDamagesMap')">
                        <div class="cardInfoBox">
                          <h2>{{ $t('homepage.pipelineDamagesMap') }}</h2>
                          <span>{{ $t('homepage.pipelineDamagesMapDescription') }}</span>
                          <br>
                          <div class="buttonContainer">
                            <a href="https://www.in.gov/iurc/pipeline-safety-division/damage-to-underground-facilities/indiana-pipeline-damages-map/"
                              target="_blank" rel="noopener noreferrer">
                              <button type="button" class="safedigButton">{{ $t('homepage.useTheMap') }}</button>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="safedigHelpfulLinksCard safedigCardLeftMargin">
                        <img src="../../../assets/safe-dig/calendar_cropped_scaled.png" width="100%" :alt="$t('homepage.eventsCalendar')">
                        <div class="cardInfoBox">
                          <h2>{{ $t('homepage.eventsCalendar') }}</h2>
                          <span>{{ $t('homepage.eventsCalendarDescription') }}</span>
                          <br>
                          <div class="buttonContainer">
                            <router-link to="/info/events">
                              <button type="button" class="safedigButton">{{ $t('homepage.upcomingEvents') }}</button>
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Helpful Links Section -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer section -->
    <div class="siteFooter footerOffWhite safedigFooter safedigFooterMargin safedigLanding">
      <div class="safedigCustomFooter">
        <div><img src="../../../assets/safe-dig/safedig_logo_grayscale-01.png" class="safedigindiana811Logo"></div>
        <p class="copyright">
          {{ $t('footer.copyright', { year: new Date().getFullYear() }) }}<br>
          {{ $t('footer.allRightsReserved') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SafeDigHeader from '@/components/safe-dig/Header.vue';
import SafeDigFooter from '@/components/safe-dig/Footer.vue';
const heroBgImage = require('@/assets/safe-dig/homepage_header_scaled.png');

export default {
  name: 'SafeDigIndianaPage',
  components: {
    SafeDigHeader,
    SafeDigFooter
  },
  data() {
    return {
      heroBgImage
    };
  }
};
</script>

<style scoped>
*,
:after,
:before {
  border: 0 solid #e5e7eb;
}

html {
  box-sizing: border-box;
}

body {
  font-family: tem, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, Liberation Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji
}



a {
  color: #3e7799;
}

a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
}

h1,
h2,
h3,
h4,
p {
  margin-bottom: 0;
}

.siteSidebarAndContentWhiteBg {
  background: #fff;
}

.siteSidebarAndContent {
  display: flex;
  flex: 1 0 auto;
}

.contentNoPadding {
  padding: 0;
}

.content {
  flex: 1;
  min-width: 2px;
  padding: 26px;
}

.homeContainer {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.homeTopContainer {
  margin: auto;
  max-width: 1200px;
  width: 100%;
}

.homeTopInnerContainer {
  align-items: center;
  display: flex;
}

.homeTopStatementContainer {
  flex: 1;
  padding: 0 19px;
}

.safedigindiana .minHeightHeaderCard {
  background-repeat: no-repeat;
  min-height: 465px;
}

.safedigindiana .safedigHomepageHeader {
  line-height: 1.1;
  text-align: center;
  color: #fff;
  font-size: 32px;
  width: 100%;
}

.safedigindiana .safedigHomepageHeader .safedigDoublePad {
  padding: 150px 0 200px;
}

.safedigindiana .safedigHomepageHeaderText {
  font-size: 20px;
  line-height: 18px;
  font-weight: 400;
  color: #fff;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.safedigindiana .safedigHomepageHeader h2 {
  color: #edcd00;
  letter-spacing: 8px;
  font-size: 30px;
  font-weight: 700;
  font-family: inherit;
  margin-bottom: 0;
  line-height: 1;
}

.safedigindiana .safedigHomepageHeader h1 {
  color: #fff;
  font-size: 96px;
  line-height: 1;
  font-weight: 700;
  font-family: inherit;
  margin-bottom: 0;
}

.safedigindiana .safedigHomepageHeader div {
  padding: 10px 14%;
}


/*  section 2 */

.safedigindiana .safedigHomepageHeaderOverlay {
  background-color: #edcd00;
  margin: -160px 80px 0;
  box-shadow: 0 0 20px 0 rgba(45, 75, 108, .5);
  padding: 80px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  z-index: 2;
  position: relative;
}

.safedigindiana .safedigProfessionalsCard {
  background-size: cover;
  background-image: url('../../../assets/safe-dig/professionals_cropped_scaled.png');
  flex-basis: 47.5%;
}

.safedigindiana .safedigHomeownersCard {
  background-size: cover;
  background-image: url('../../../assets/safe-dig/homeowners_cropped_scaled.png');
  flex-basis: 47.5%;
  margin-left: 5%;
}

.safedigindiana .safedigCardOverlay {
  background-color: rgba(45, 75, 108, .5333333333);
  padding: 90px 0;
}

.safedigindiana .safedigCardOverlay span {
  color: #fff;
  font-weight: 700;
  letter-spacing: 6px;
}

.safedigindiana .marginTop2 {
  margin-top: 32px;
}

.safedigindiana .safedigButton {
  color: #2d4b6c;
  background-color: #edcd00;
  font-weight: 700;
  padding: 5px 10px;
}

/* section 3 – Helpful Links: cards overlap blue band (top) and footerOffWhite (bottom) */
.safedigindiana .safedigHelpfulLinksWrapper {
  width: 100%;
  text-align: center;
  margin-top: 50px;
  padding: 0 5%;
  position: relative;
}

.safedigindiana .safedigHelpfulLinksHeader {
  position: relative;
  z-index: 1;
  margin: 0 0 0;
  margin-bottom: 50px;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 3px;
  color: #5a6d7d;
}

/* Slate blue band behind the cards */
.safedigindiana .safedigHelpfulLinksBand {
  position: absolute;
  left: 0;
  right: 0;
  top: 176px;
  bottom: 70px;
  background-color: #869eb8;
  z-index: 0;
}

/* Cards row: overlaps band (top) and footer (bottom) */
.safedigindiana .safedigHelpfulLinksCardsRow {
  position: relative;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: 70px;
  gap: 0 5%;
}

.safedigindiana .safedigHelpfulLinksCard {
  flex: 0 1 30%;
  min-width: 260px;
  text-align: left;
  position: relative;
  background: #fff;
  box-shadow: 0 4px 20px rgba(45, 75, 108, 0.25);
}

.safedigindiana .safedigHelpfulLinksCard img {
  display: block;
  width: 100%;
  height: auto;
}

.safedigindiana .safedigHelpfulLinksCard .cardInfoBox {
  padding: 20px;
  background-color: #fff;
  min-height: 220px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.safedigindiana .safedigCardLeftMargin {
  margin-left: 0;
}

.safedigindiana .cardInfoBox h2 {
  font-size: 20px;
  font-weight: 700;
  color: #5a6d7d;
}

.safedigindiana .cardInfoBox span {
  font-size: 15px;
  color: #6b7280;
  flex: 1;
}

.safedigindiana .safedigHelpfulLinksCard .buttonContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  text-align: center;
  margin-top: auto;
  padding-top: 16px;
  bottom: auto;
}

.safedigindiana .safedigHelpfulLinksCard button {
  font-size: 11px;
}

.safedigindiana .safedigButton {
  color: #2d4b6c;
  background-color: #edcd00;
  font-weight: 700;
  padding: 8px 16px;
}

/* section 4 footer section – pull up so cards overlap footerOffWhite */
.safedigindiana .safedigFooterMargin {
  margin-top: -120px;
  position: relative;
  z-index: 1;
}

.safedigindiana .safedigFooter {
  background: #e8e8e8;
  height: auto;
}

.safedigindiana .safedigLanding .safedigCustomFooter {
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.safedigindiana .safedigCustomFooter img {
  height: 60px;
  width: auto;
}

.safedigindiana .safedigCustomFooter p {
  color: #b8b8b8;
  margin-left: 32px;
}

.copyright {
  align-items: center;
  color: #fff;
  font-size: 14px;
  margin-bottom: 0;
}

/* ========== RESPONSIVE – TABLET & MOBILE ========== */

@media screen and (max-width: 1200px) {
  .safedigindiana .safedigHelpfulLinksCardsRow {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 16px 2%;
    padding-bottom: 60px;
  }
}

/* Tablet */
@media (max-width: 768px) {
  .safedigindiana .safedigHomepageHeaderOverlay {
    margin: -96px 24px 0;
    padding: 48px 24px;
  }

  .safedigindiana .safedigHomepageHeaderOverlay span {
    font-size: 21px !important;
    letter-spacing: 3px !important;
    padding-bottom: 32px !important;
  }


  .safedigindiana .safedigHomepageHeader .safedigDoublePad {
    padding: 80px 24px 120px;
  }

  .safedigindiana .safedigProfessionalsCard,
  .safedigindiana .safedigHomeownersCard {
    flex-basis: 100%;
  }

  .safedigindiana .safedigHomeownersCard {
    margin-left: 0;
    margin-top: 16px;
  }

  .safedigindiana .safedigCardOverlay {
    padding: 48px 0;
  }

  /* Helpful Links – tablet */
  .safedigindiana .safedigHelpfulLinksWrapper {
    margin-top: 48px;
    padding: 0 3%;
  }

  .safedigindiana .safedigHelpfulLinksHeader {
    font-size: 19px;
    letter-spacing: 2px;
    margin-bottom: 32px;
  }

  .safedigindiana .safedigHelpfulLinksBand {
    top: 128px;
    bottom: 30px;
  }
  .safedigindiana .safedigHomepageHeader h1 {
    font-size: 56px;
  }

  .safedigindiana .safedigHelpfulLinksCardsRow {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 16px 2%;
    padding-bottom: 36px;
  }

  .safedigindiana .safedigHelpfulLinksCard {
    flex: 0 1 48%;
    min-width: 0;
  }

  .safedigindiana .safedigHelpfulLinksCard .cardInfoBox {
    min-height: 200px;
  }

  .safedigindiana .safedigFooterMargin {
    margin-top: -80px;
  }

  .safedigindiana .safedigLanding .safedigCustomFooter {
    padding: 80px 24px;
    flex-direction: column;
    text-align: center;
  }

  .safedigindiana .safedigCustomFooter p {
    margin-left: 0;
    margin-top: 16px;
  }
}

/* Mobile */
@media (max-width: 576px) {
  .safedigindiana .content {
    padding: 0 13px;
  }

  .safedigindiana .minHeightHeaderCard {
    min-height: 320px;
  }

  .safedigindiana .safedigHomepageHeader{
    line-height: 0.9;
  }

  .safedigindiana .safedigHomepageHeader .safedigDoublePad {
    padding: 60px 13px 100px;
  }

  .safedigindiana .safedigHomepageHeader h2 {
    font-size: 18px;
    letter-spacing: 3px;
  }

  .safedigindiana .safedigHomepageHeader h1 {
    font-size: 40px;
  }

  .safedigindiana .safedigHomepageHeaderText {
    font-size: 16px;
    line-height: 14px !important;
  }

  .safedigindiana .safedigHomepageHeader div {
    padding: 10px 5%;
  }

  .safedigindiana .safedigHomepageHeaderOverlay {
    margin: -96px 13px 0;
    padding: 32px 16px;
  }

  .safedigindiana .safedigHomepageHeaderOverlay span {
    font-size: 16px !important;
    letter-spacing: 2px !important;
    padding-bottom: 24px !important;
  }

  .safedigindiana .safedigCardOverlay {
    padding: 54px 0;
  }

  /* Helpful Links – mobile: stack cards, full width */
  .safedigindiana .safedigHelpfulLinksWrapper {
    margin-top: 32px;
    padding: 0 13px;
  }

  .safedigindiana .safedigHelpfulLinksHeader {
    font-size: 16px;
    letter-spacing: 2px;
    margin-bottom: 24px;
  }

  .safedigindiana .safedigHelpfulLinksBand {
    top: 96px;
    bottom: 40px;
  }

  .safedigindiana .safedigHelpfulLinksCardsRow {
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding-bottom: 32px;
  }

  .safedigindiana .safedigHelpfulLinksCard {
    flex: 0 0 auto;
    width: 100%;
    max-width: 360px;
    min-width: 0;
  }

  .safedigindiana .safedigHelpfulLinksCard.safedigCardLeftMargin {
    margin-left: 0;
  }

  .safedigindiana .safedigHelpfulLinksCard .cardInfoBox {
    min-height: auto;
    padding: 16px;
  }

  .safedigindiana .cardInfoBox h2 {
    font-size: 18px;
  }

  .safedigindiana .cardInfoBox span {
    font-size: 14px;
  }

  .safedigindiana .safedigHelpfulLinksCard .buttonContainer {
    padding-top: 12px;
  }

  .safedigindiana .safedigHelpfulLinksCard .buttonContainer a {
    display: inline-block;
    margin: 0 2px;
  }

  .safedigindiana .safedigFooterMargin {
    margin-top: -60px;
  }

  .safedigindiana .safedigLanding .safedigCustomFooter {
    padding: 60px 16px;
  }

  .safedigindiana .safedigCustomFooter img {
    height: 40px;
  }

  .safedigindiana .safedigCustomFooter p {
    font-size: 12px;
  }
}
</style>
